import styled from "styled-components";

export const FooterNovoConhecerSocialContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  .footernovoconhecersocial {
    display: flex;
    justify-content: space-between;
    width: 292px;
    height: 40px;
    margin-top: 40px;

    .footernovoconhecersocial__item {
      width: 40px;
      height: 40px;

      .cmp-image__image {
        width: 40px;
        height: 40px;
      }
    }
  }
`;
